import PropTypes from 'prop-types'
import React from 'react'

const TeamInfoTooltip = ({ teamInfo }) =>
  teamInfo ? (
    <div className='show-team-info-tooltip'>
      <h4>Team info</h4>
      <div>
        <span>Team Name:</span>
        <strong>{teamInfo.teamName}</strong>
      </div>
      <div>
        <span>Account Manager:</span>
        <strong>{teamInfo.accountManager}</strong>
      </div>
      <div>
        <span>Team Leader:</span>
        <strong>{teamInfo.teamLeader}</strong>
      </div>
      <div>
        <span>Atheneum Office:</span>
        <strong>{teamInfo.atheneumOffice}</strong>
      </div>
    </div>
  ) : (
    <div>Team info unavailable</div>
  )
TeamInfoTooltip.propTypes = {
  teamInfo: PropTypes.object
}

export default TeamInfoTooltip
